<template>
  <div class="sale-normal-info-container">
    <el-card>
      <template #header>
        <TitleItem title="销售信息" />
      </template>
      <el-form label-width="125px">
        <el-form-item label="套餐库存" required>
          <el-input style="width: 202px" type="number" :min="0" v-model="currNum" placeholder="请输入套餐库存" @change="changeStock"></el-input>
        </el-form-item>
        <el-form-item label="销售单位" required>
          <el-select style="width: 202px" filterable v-model="mUnit" placeholder="请选择销售单位" @change="unitSelectChange">
            <el-option v-for="unitItem in unitsList" :key="unitItem.unitsCode" :label="unitItem.unitsName" :value="unitItem.unitsCode"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
import TitleItem from "./TitleItem.vue";

export default {
  components: {
    TitleItem,
  },
  data() {
    return {
      isOA: false,
      availableSpecList: [], // specList过滤掉没输入规格项和规格值的数组
      stockType: 1, // 注释查看stockTypeArr里的注释
      currNum: "", // 当前库存 单规格时必填，多规格非必填
      spec: "", // 元/销售单位
      mUnit: "", //单规格时的销售单位
      sUnit: "", //单规格时的计量单位
      relationNo: "", // 货品编码
      shopType: 2, // == 2 展示 是否允许代销这行
      isDealership: 1, //是否允许代销 是否代销 0:否 1:是
      isPublicDisplayPrice: 0, // 价格：仅对客户关系 是1 否0,
      minOrderQuantity: "", // 起订量：非必填，仅支持输入数字和小数点；起订量根据商品分类校验
      unitRatio: "", // 换算值
      salesVolumeUnreal: "", // 虚拟销量
    };
  },
  computed: {
    ...mapState("publishGoods/publishGoods", ["unitsList", "goodsDetail", "spuInfoObj", "stockTypeArr", "cateModel", "shopConfig"]),
  },
  watch: {
    shopConfig(newVal, oldVal) {
      console.log("shopConfig", this.shopConfig);
      this.shopType = newVal.shopType;
      if (newVal && oldVal && (newVal.goodsPriceDigit != oldVal.goodsAmountDigit || newVal.goodsPriceDigit != oldVal.goodsPriceDigit)) {
        this.minOrderQuantity = "";
      }
    },
    //商品详情数据
    goodsDetail(newVal) {
      this.currNum = newVal.firstSku.currQuantity;
      this.mUnit = newVal.firstSku.mUnit;
      this.sUnit = newVal.firstSku.sUnit;
      this.spec = newVal.firstSku.spec;
      this.isOA = newVal.firstSku.isoa == 1;
      this.stockType = newVal.firstSku.stockType;
      this.minOrderQuantity = newVal.firstSku.minOrderQuantity;
      this.unitRatio = newVal.firstSku.unitRatio;
      this.salesVolumeUnreal = newVal.firstSku.salesVolumeUnreal;

      this.isDealership = newVal.firstSku.isDealership;
      this.isPublicDisplayPrice = newVal.firstSku.isPublicDisplayPrice;
    },
    //编辑商品的时候会有spu信息,生成多规格数据
    spuInfoObj(newVal) {
      const specialSpecArr = JSON.parse(newVal.specialSpec).data;

      this.specList = specialSpecArr.map((item) => {
        return {
          id: Date.now() + Math.floor(Math.random() * 100),
          specType: item.spec,
          specValue: item.values,
        };
      });

      this.$nextTick(() => {
        this.$refs.priceInventoryRef.editProductSetSkusData(newVal.skuList);
      });
    },
  },
  methods: {
    //选择完计量单位后,拼接字符串
    unitSelectChange(unitsCode) {
      const unitItem = this.unitsList.find((item) => item.unitsCode === unitsCode);
      this.spec = `元/${unitItem.unitsName}`;
    },
    //库存,取整数
    changeStock() {
      const stockArr = this.currNum.split(".");
      if (stockArr.length <= 1) {
        if (this.currNum > 99999) {
          this.currNum = 99999;
        }
        if (this.currNum <= 0) {
          this.currNum = 0;
        }
        return;
      }
      this.currNum = stockArr[0];
      if (this.currNum > 99999) {
        this.currNum = 99999;
      }
      if (this.currNum <= 0) {
        this.currNum = 0;
      }
    },
    subMitCheck() {
      if (!this.currNum) {
        this.$message.error("请填写库存");
        return;
      }
      if (!this.mUnit) {
        this.$message.error("请选择销售单位");
        return;
      }

      const saleInfoObj = {
        stockType: this.stockType,
        currNum: this.currNum,
        currQuantity: this.currNum,
        mUnit: this.mUnit,
        spec: this.spec,
        minOrderQuantity: this.minOrderQuantity,
        relationNo: this.relationNo,
        isDealership: this.isDealership,
        unitRatio: this.unitRatio,
        sUnit: this.sUnit,
        salesVolumeUnreal: this.salesVolumeUnreal,
        isPublicDisplayPrice: this.isPublicDisplayPrice,
      };
      //编辑商品要传skuid
      if (this.goodsDetail) {
        saleInfoObj.goodsId = this.goodsDetail.firstSku.goodsId;
      }

      //新增商品才赋值初始库存
      if (!this.goodsDetail) {
        saleInfoObj.origNum = this.currNum;
      }

      return saleInfoObj;
    },
  },
};
</script>

<style lang="scss" scoped>
.sale-normal-info-container {
  padding-top: 20px;
}
</style>
